import React, { Component } from 'react';

// import SideBar from "../../../components/admin/side";
import ScholarFacet from "../../../components/scholar/admin/list/facet";
import SearchBox from '../../../components/scholar/admin/list/search';
import ScholarItem from '../../../components/scholar/admin/list/item'
import * as func from "../../../utils/functions";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import * as Actions from "../../../store/modules/scholars";
import {PropTypes} from "prop-types";
import ReactPaginate from "react-paginate";
import {objectToQueryString, pushUrl} from "../../../utils/functions";
import FrontFooter from '../../../components/etc/footer/';
import {BASE_PATH} from "../../../wpconfig";

class ScholarList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isInit: false,
      action : 'admin/scholars',
      url : 'wp-admin/admin.php?page=scholar&',
    }
  }

  componentDidMount() {
    if(location.search.substring(1)) {
      this.props.dataActions.setScholars({'param' : func.parseParams(location.search.substring(1))});
    }
    // 이해 안됨.
    setTimeout(() => {
      this.getList();
    }, 0);
  }

  getList() {
    func.getData(this.state.action, this.props.param).then((response) => {
      this.setState({
        isInit: true,
      })
      this.props.dataActions.setScholars(response);
    });
  }

  handlePageClick = (page) => {
    const paged = page.selected + 1;

    let param = this.props.param;
    param['current_page'] = paged;

    const { dataActions } = this.props;
    dataActions.setScholars({"param": param});

    setTimeout(() => {
      func.getData(this.state.action, this.props.param).then((response) => {
        this.props.dataActions.setScholars(response);

        const url = objectToQueryString(this.props.param);
        pushUrl('검색', "admin.php?page=scholar&" + url, this.props.param);
      });
    }, 0);
  }

  order = (key) => {
    let param = this.props.param;
    if(param.order_by === key) {
      if (param.order === 'asc')
        param.order = 'desc'
      else
        param.order = 'asc'
    } else {
      param.order_by = key
      param.order = 'desc'
    }

    const {dataActions} = this.props;
    dataActions.setScholars({"param": param});

    func.getData(this.state.action, param).then((response) => {
      this.props.dataActions.setScholars(response);

      const url = objectToQueryString(this.props.param);
      pushUrl('검색', BASE_PATH + this.state.url + url, this.props.param);
    });
  }

  onRecordCheck = () => {
    const checkedRecords = this.props.checkedRecords;
    if (event.target.checked) {
      checkedRecords.push(event.target.value)
      this.props.dataActions.setScholars({checkedRecords : checkedRecords});
    } else {
      const idx = checkedRecords.indexOf(event.target.value)
      if (idx > -1) checkedRecords.splice(idx, 1)
      this.props.dataActions.setScholars({checkedRecords : checkedRecords});
    }
    this.forceUpdate()
  }

  compareArray = function(a, b){
    if(JSON.stringify(a) === JSON.stringify(b)) {
      return true;
    } else{ return false; }
  }

  isAllChecked () {
    let recordsId = [];
    this.props.records.map((record, index) => {
      recordsId.push(record.scholar_id)
    })
    let checkedRecordsId = this.props.checkedRecords;

    let nameSort = function(a,b){
      if(a < b){
        return -1
      }else if(a > b){
        return 1;
      }else{
        return 0;
      }
    }

    recordsId.sort(nameSort);
    checkedRecordsId.sort(nameSort);

    return this.compareArray(recordsId, checkedRecordsId)
  }

  onAllRecordCheck = () => {
    const checkedRecords = [];
    if (event.target.checked) {
      {this.props.records.map((record, index) => {
        checkedRecords.push(record.scholar_id)
      })}
    }
    this.props.dataActions.setScholars({checkedRecords : checkedRecords});
    this.forceUpdate()
  }

  render() {
    const { isInit } = this.state;
    const { records } = this.props;

    const allChecked = this.isAllChecked()
    return (
      <div className="container-fluid mt-3 admin-layout">
        <div className="row">
          <div className="admin-sidebar">
            <ScholarFacet />
          </div>
          <div className="col admin-contents">
            <SearchBox />

            <table className="table table-striped table-thin border-bottom scholar-list">
              <thead>
                <tr>
                  <th scope="col">
                    <input type="checkbox" className="ml-0"
                           checked={allChecked}
                           onChange={this.onAllRecordCheck} />
                  </th>
                  <th scope="col">NO</th>
                  <th scope="col">관리<br/>번호</th>
                  <th scope="col">연구자</th>
                  <th scope="col">단과대학</th>
                  <th scope="col">학과</th>
                  <th scope="col">전공</th>
                  <th scope="col">직급</th>
                  <th scope="col">논문수</th>
                  <th scope="col">본인확인</th>
                  <th scope="col">상태</th>
                  <th scope="col">입력일</th>
                  <th scope="col">수정일</th>
                </tr>
              </thead>
              <tbody>
                {!isInit && records.length <= 0 && <tr><td colSpan={14}>로딩중입니다.</td></tr>}
                {isInit && records.length <= 0 && <tr><td colSpan={14}>결과가 없습니다.</td></tr>}
                {records.map((record, index) => {
                  const no = this.props.totalRecords - ((this.props.param.current_page - 1) * this.props.param.record_per_page) - index;
                  const checked = this.props.checkedRecords.includes(record.scholar_id)
                  return (
                    <ScholarItem key={index} record={record} no={no}
                                 onRecordCheck={this.onRecordCheck}
                                 checked={checked}/>
                  )
                })}
              </tbody>
            </table>
            {this.props.totalPage > 1 &&
            <div className="mt-4">
              <div>
                <div className="paging-wrap">
                  <ReactPaginate
                      forcePage={Number(this.props.param.current_page)-1}
                      pageCount={this.props.totalPage}
                      marginPagesDisplayed={2}
                      pageRangeDisplayed={2}
                      onPageChange={this.handlePageClick}
                      containerClassName={'pagination'}
                      activeClassName={'active'}
                      pageClassName={'page-item'}
                      pageLinkClassName={'page-link'}
                      previousClassName={'page-item page-item-prev'}
                      previousLinkClassName={'page-link'}
                      nextClassName={'page-item page-item-next'}
                      nextLinkClassName={'page-link'}
                  />
                </div>
              </div>
            </div>
            }
          </div>
        </div>
				<FrontFooter
					param={this.props.param}
					facet={this.props.facet}
					dataActions={this.props.dataActions} />
      </div>
    )
  }
}

export default connect(
    (state) => ({
      param: state.scholars.param ? state.scholars.param : {},
      records : state.scholars.records ? state.scholars.records : [],
      checkedRecords : state.scholars.checkedRecords ? state.scholars.checkedRecords : [],
      facet : state.scholars.facet ? state.scholars.facet : {},
      totalRecords : state.scholars.totalRecords ? state.scholars.totalRecords : 0,
      totalPage : state.scholars.totalPage ? state.scholars.totalPage : 0,
    }),
    (dispatch) => ({
      dataActions: bindActionCreators(Actions, dispatch)
    }),
)(ScholarList)

ScholarList.propTypes = {
  param : PropTypes.object,
  records : PropTypes.array,
  facet : PropTypes.object,
  totalRecords : PropTypes.number,
  totalPage : PropTypes.number,
};
